import React from "react";
import StatusChip from "./system/StatusChip";

/**
 * ExpirationBadge — thin wrapper around the unified <StatusChip />.
 *
 * Maps the legacy urgency keys (`fresh` / `attention` / `urgent` /
 * `expired`) to the design-system tones so every page that already
 * uses <ExpirationBadge> instantly renders with the new soft chip
 * styling — no per-page change required.
 */
const MAP = {
  fresh:     { tone: "fresh",   label: "Fresh" },
  attention: { tone: "soon",    label: "Soon" },
  urgent:    { tone: "urgent",  label: "Urgent" },
  expired:   { tone: "expired", label: "Expired" },
};

export function ExpirationBadge({ urgency, children, className = "" }) {
  const cfg = MAP[urgency] || MAP.fresh;
  return (
    <StatusChip
      tone={cfg.tone}
      className={className}
      data-testid={`expiration-badge-${urgency}`}
    >
      {children || cfg.label}
    </StatusChip>
  );
}

export function daysUntil(iso) {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const d = new Date(iso);
    d.setHours(0, 0, 0, 0);
    return Math.round((d - today) / 86400000);
  } catch {
    return null;
  }
}
